import { findKey, intersection } from 'lodash';

const rolesMap = {
  BENCH: ['USER', 'SALES', 'MANAGER'],
  CLIENT: ['UNPAID_CLIENT', 'DEMO_CLIENT', 'CLIENT'],
  TAX_ACCOUNTANT: ['TAX_ACCOUNTANT'],
};

export const getRoleGroup = roles =>
  findKey(rolesMap, rolesMatch => intersection(rolesMatch, roles).length > 0);

export default { getRoleGroup };
